/* eslint-disable */
import React, { useState } from "react";
import Svg from "_assets/svg";

const FormTitle = ({ id, label, placeholder, value, error, onChange, source, classNameLabel, inputRequired }) => {
  const [isRevealPwd, setIsRevealPwd] = useState(false);

  const handleSetIsRevealPwd = () => {
    setIsRevealPwd(!isRevealPwd)
  }

  return (
    <div className={`${source === 'login' ? 'input-auth-login' : 'input-auth'} position-relative`}>
      <label className={`${classNameLabel} form-label`}>{label} {inputRequired && <span className="cl-primary">*</span>}</label>
      <div className="position-relative">
        <input
          type={isRevealPwd ? "text" : "password"}
          className={`form-control cl-neutral-700 fsize-12 fweight-500 ${!error?.isValid && "has-error"}`}
          id={id}
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
        <div
          className="position-absolute"
          style={{ right: '2%', top: '15%', outline: 'none', zIndex: '90' }}
          role="button"
          tabIndex={0}
          onClick={() => handleSetIsRevealPwd()}
          onKeyDown={() => handleSetIsRevealPwd()}
        >
          {isRevealPwd ? (
            <img
              src={Svg.slash_show.default}
              alt="imgPass"
            />
          ) : (
            <img
              src={Svg.slash_hide.default}
              alt="imgPass"
            />
          )}
        </div>
      </div>
      {!error?.isValid && <div className="text-danger text-error">{error?.msg}</div>}
    </div>
  );
};

export default FormTitle;
